import React, { PropTypes } from 'react';

import { Link } from 'react-router'


class TagListTD extends React.Component {
  constructor(props) {
		super(props);
	}

	static propTypes = {
		client: PropTypes.object.isRequired
	}

	render() {
		let { client } = this.props;
		let {tag_name_list} = client;
    
		return (
			<div className='client-tag-TD'>
        {tag_name_list.map((tag) => {
          return <span key={tag} className='tags'>{tag}</span>
        })}
			</div>
		);
  }
}

export default TagListTD;



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/TagListTD.js